import { IS_SERVER, NEXT_PUBLIC_HOST_NAME } from '@app/core-features/env/env-shared';
import logger from '@app/core-features/logger/logger';

export const getBrowserCookie = (cookieName: string): null | string => {
    if (IS_SERVER) {
        return null;
    }
    try {
        const cookies: string[] = window.document.cookie.split(';');
        let cookieValue = null;
        cookies.find((cookie) => {
            const [key, value] = cookie.trim().split('=');
            if (key === cookieName) {
                cookieValue = value;
            }

            return key === cookieName;
        });

        return cookieValue;
    } catch (_error) {
        logger.error(`Could not get browser cookie ${cookieName}, cookies: ${window.document.cookie}`);
        return null;
    }
};

const defaultCookieConfig: BrowserCookieConfig = {
    expires: '',
    isTopLevelDomain: false,
    isSecure: false,
    sameSite: 'Lax',
};

type BrowserCookieConfig = {
    domain?: string;
    expires?: string;
    isSecure?: boolean;
    isTopLevelDomain: boolean;
    sameSite?: 'Lax' | 'None' | 'Strict';
};

export const setBrowserCookie = (cookieName: string, cookieValue: string, cookieConfig?: BrowserCookieConfig): void => {
    const config = { ...defaultCookieConfig, ...cookieConfig };

    if (IS_SERVER) {
        return;
    }

    try {
        const cookie = `${cookieName}=${cookieValue}`;
        const path = 'path=/';
        const domain = `domain=${config.isTopLevelDomain && !location.host.includes('127.0.0.1') ? NEXT_PUBLIC_HOST_NAME : location.hostname}`;
        const secure = config.isSecure ? 'secure' : null;
        const sameSiteValue = `SameSite=${config.sameSite}`;
        const expires = config.expires || (cookieValue === '' ? buildCookieTTL(-100) : undefined);
        window.document.cookie = [cookie, expires, domain, path, secure, sameSiteValue].filter(Boolean).join('; ');
    } catch (_error) {
        logger.error(`Could not set browser cookie ${cookieName}`);
        return;
    }
};

const buildCookieTTL = (seconds: number): string => {
    const date = new Date();
    date.setSeconds(date.getSeconds() + seconds);
    return `expires=${date.toUTCString()}`;
};
